// extracted by mini-css-extract-plugin
export var button = "_15-1";
export var featuredLink = "_15-4";
export var spinner = "_15-2";
export var spinnerContainer = "_15-3";
export var text = "_15-0";